module.exports = __webpack_public_path__ + "static/media/india.0f215935.png";